import {
  EnvConfig,
  MediaQuestionConfig,
  MediaResponseState,
  MediaType,
  useFindMedia,
} from '@gripp/shared-logic';
import { useMemo, useState } from 'react';
import { View } from 'react-native';
import { getImageThumbnailWidth } from '../../../../../components/media/getMediaThumbnailWidth';
import type { ImageGalleryImage } from '../../../../crop-circle/Components/ImageGallery';
import { useIssueContext } from '../../../../issue/issueContext';
import { MessageMedia } from '../../../../issue/messageMedia';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const MediaQuestionMessage: RoutineQuestionMessage<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionMessageProps<MediaQuestionConfig, MediaResponseState>
) => {
  const { response } = props;
  const [mediaWidth, setMediaWidth] = useState<number>();
  const onViewImages = useIssueContext()?.onViewImages;
  const media = useFindMedia({
    filter: {
      id: { in: response.mediaIds },
    },
  });

  // Only images are viewable in the panel, so the gallery is indexed over the
  // images alone — `media` also carries videos, which keep their own handling.
  const galleryImages = useMemo<ImageGalleryImage[]>(
    () =>
      (media ?? [])
        .filter((item) => item.type === MediaType.Image)
        .map((item) => ({
          id: item.id,
          url: `${EnvConfig.mediaUrl}/images/${item.id}/original.${item.extension}`,
          name: item.name,
        })),
    [media]
  );

  const handleImagePress = onViewImages
    ? (mediaId: string) => {
        const index = galleryImages.findIndex((image) => image.id === mediaId);
        if (index >= 0) {
          onViewImages(galleryImages, index);
        }
      }
    : undefined;

  return (
    media && (
      <View
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          const thumbnailWidth = getImageThumbnailWidth(width);
          setMediaWidth(thumbnailWidth);
        }}
      >
        <MessageMedia
          media={media}
          displayWidth={mediaWidth}
          onImagePress={handleImagePress}
        />
      </View>
    )
  );
};
